import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { theme } from '../styles/theme';

const OrderSuccess = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: theme.palette.background.default }}>
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Typography variant="h3" component="h1" align="center" sx={{ color: theme.palette.primary.main }}>
          Order Placed Successfully!
        </Typography>
        <Typography variant="h6" align="center" sx={{ mt: 4, color: theme.palette.secondary.main }}>
          Thank you for your purchase. We will contact you soon for delivery details.
        </Typography>
      </Container>
    </Box>
  );
};

export default OrderSuccess;